import { Navigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePermission } from "./usePermission";
import { canOpenNetworkMemberProfile } from "../utils/necMembership";

export default function SelfOrPermissionRoute({
  permissionKey,
  children,
  idParam = "id",
}) {
  const { canByKey, hasPolicyRole, isSuperAdmin } = usePermission();
  const params = useParams();
  const location = useLocation();
  const stateUserId = useSelector((state) => state.user?.userId);
  const userDetails = useSelector((state) => state.user?.userDetails);
  const searchParams = new URLSearchParams(location.search);

  const targetUserId = params?.[idParam];
  const targetUserIdFromQuery = searchParams.get("userId");
  const targetUserIdFromState =
    location.state?.userId || location.state?.profileUserId;
  const loggedInUserId = stateUserId || localStorage.getItem("userId");
  const isSelfByParam =
    targetUserId &&
    loggedInUserId &&
    String(targetUserId) === String(loggedInUserId);
  const isSelfByQuery =
    targetUserIdFromQuery &&
    loggedInUserId &&
    String(targetUserIdFromQuery) === String(loggedInUserId);
  const isSelfByState =
    targetUserIdFromState &&
    loggedInUserId &&
    String(targetUserIdFromState) === String(loggedInUserId);
  const isSelf =
    isSelfByParam ||
    isSelfByQuery ||
    isSelfByState ||
    (!targetUserId && !targetUserIdFromQuery && !targetUserIdFromState && Boolean(loggedInUserId));

  if (isSelf) return children;
  if (isSuperAdmin || hasPolicyRole("VIEWER")) return children;
  if (location.state?.canOpenMemberProfile === true) return children;
  if (permissionKey && canByKey(permissionKey)) return children;
  if (canByKey("COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_VIEW")) return children;
  if (canByKey("COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_LIST")) return children;
  if (canByKey("CORE_NETWORK_VIEW")) return children;
  if (
    canOpenNetworkMemberProfile({
      userDetails,
      isSuperAdmin,
      hasPolicyRole,
      canByKey,
    })
  ) {
    return children;
  }

  return <Navigate to="/403" replace />;
}





